import { TableBody, TableCell, TableRow } from '@material-ui/core';
import React from 'react';
import Typography from '../../../../components/common/Typography';
import { useTrans } from '../../../../services/i18n';
import { formatPrettyUSD } from '../../../../utils/numberUtils';

function NaicsTable({ statistics }) {
  const { trans } = useTrans();
  return (
    <>
      <TableRow>
        <TableCell align="left" width="50%">
          <Typography variant="body2" weight="800">
            {trans('naics')}
          </Typography>
        </TableCell>
        <TableCell align="left" width="25%">
          <Typography variant="body2" weight="800">
            {trans('amount-won')}
          </Typography>
        </TableCell>
        <TableCell align="left" width="25%">
          <Typography variant="body2" weight="800">
            {trans('amount-lost')}
          </Typography>
        </TableCell>
      </TableRow>
      <TableBody>
        {statistics?.naics.map((naic, index) => (
          <TableRow>
            <TableCell align="left">
              <Typography variant="body2" color="hint">
                {naic.id}
              </Typography>
            </TableCell>
            <TableCell align="left">
              <Typography variant="body2" color="hint">
                {formatPrettyUSD(naic.amountWon)}
              </Typography>
            </TableCell>
            <TableCell align="left">
              <Typography variant="body2" color="hint">
                {formatPrettyUSD(naic.amountLost)}
              </Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
}

export default NaicsTable;
